import { mobileRouteService } from '@/_services';
import { createRouteStopItem } from '../day-route/dayRouteModel';

export async function loadRouteStopDetail({
  routeStop: routeStopFromContext,
  planId,
  routeStopId,
  vehicleId
}) {
  if (routeStopFromContext) {
    return routeStopFromContext;
  }

  const routeStops = await mobileRouteService.loadRouteStopsByVehiclePlan(
    planId,
    vehicleId
  );

  const routeStop = routeStops
    .map(createRouteStopItem)
    .find((item) => equalsRouteStopId(item.stop.stopId, routeStopId));

  return routeStop ?? null;
}

function equalsRouteStopId(left, right) {
  return left?.trim?.().toLowerCase() === right?.trim?.().toLowerCase();
}
